import Vue from 'vue'
import Utils from './Utils'
import Auth from './Auth'
export default {
  url: Auth.getUrl('email-account'),
  paginate (meta) {
    return Utils.paginate(this.url, meta)
  },
  get (id) {
    return Vue.http.get(this.url + '/' + id)
  },
  test (id, message) {
    return Vue.http.post(this.url + '/' + id + '/test', message)
  },
  names () {
    return Vue.http.get(this.url + '/names')
  },
  create (data) {
    return Vue.http.post(this.url, data)
  },
  update (data) {
    return Vue.http.put(this.url + '/' + data.id, data)
  },
  remove (id) {
    return Vue.http.delete(this.url + '/' + id)
  },
  getBaseItem () {
    return {
      id: null,
      name: '',
      host: '',
      port: 587,
      from_address: '',
      from_name: '',
      encryption: '',
      username: '',
      password: '',
      limit: 100,
      is_default: true,
      status: 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/Accounts.js